'use client';

import { Toolbar, AppBar, useMediaQuery } from '@mui/material';
import { FC } from 'react';

import { Logo } from '../../common';
import { UserInfoPanel } from '../../common/UserInfo';
import { Balance } from '../Balance';
import { Navigation } from '../Navigation';

import styles from './HeaderBar.module.scss';

type HeaderBarProps = {
  isAuthorized: boolean;
};

export const HeaderBar: FC<HeaderBarProps> = (props) => {
  const { isAuthorized } = props;

  const isSmallSize = useMediaQuery('(max-width:960px)');

  return (
    <AppBar position={isSmallSize ? 'sticky' : 'static'}>
      <Toolbar className={styles.headerLayout}>
        <div className={styles.mobileContainer}>
          <Navigation isAuthorized={isAuthorized} />
          <Logo />
        </div>

        <div className={styles.desktopContainer}>
          <Balance />
          <UserInfoPanel />
        </div>
      </Toolbar>
    </AppBar>
  );
};
